import * as ga from '../tracking-googleanalytics.ts';
import './login2.ts';
import './CssOnScroll.ts';

ga.page(window.location.pathname);
